export default "__VITE_ASSET__DKBieH4J__"